module.exports = __webpack_public_path__ + "static/media/pimiento.75f7eb57.png";